import { Component, computed, Input, Signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ToggleDarkComponent } from "../../../../common/toggle-dark/toggle-dark.component";
import { AuthService } from '../../../../services/Auth/auth.service';
import { NgClass } from '@angular/common';
import { SidebarService } from '../../../../services/sidebar/sidebar.service';

@Component({
  selector: 'admin-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, ToggleDarkComponent, NgClass],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  sidebarLinks: any[] = [];

  constructor(
    private authService: AuthService,
    public sidebar: SidebarService,
  ){
    this.initList()
  }


  initList() {
    this.sidebarLinks = [
      {
        label: 'Home',
        icon: 'pi pi-home',
        href: 'home',
      },
      {
        label: 'Gallery',
        icon: 'pi pi-images',
        href: 'gallery',
      },
      {
        label: 'Events',
        icon: 'pi pi-calendar',
        href: 'events',
      },
      {
        label: 'Volunteer',
        icon: 'pi pi-users',
        href: 'volunteer',
      },
      {
        label: 'Apparel',
        icon: 'pi pi-shopping-bag',
        href: 'apparel',
      },
      {
        label: 'Awards',
        icon: 'pi pi-trophy',
        href: 'awards',
      },
      {
        label: 'Download',
        icon: 'pi pi-download',
        href: 'download',
      },
      {
        label: 'Registration',
        icon: 'pi pi-sign-in',
        href: 'registration',
      },
      {
        label: 'Contact Info',
        icon: 'pi pi-envelope',
        href: 'contact-us',
      }

    ];
  }

  logout(){
    this.authService.logout();
  }
}
